import { useFrame, useLoader, useThree } from "@react-three/fiber"
import * as TWEEN from "@tweenjs/tween.js"
import {
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react"
import { Color } from "three"
import { TextureLoader } from "three/src/loaders/TextureLoader"

const Earth = forwardRef((props, ref) => {
  const earthRef = useRef()
  const [isRotating, setIsRotating] = useState(true)
  const [colorMap, bumpMap, specularMap] = useLoader(TextureLoader, [
    "/textures/7MXox-modified.jpg",
    "/textures/8081_earthbump10k.jpg",
    "/textures/3tqI6.jpg",
  ])

  useFrame(() => {
    if (!isRotating) {
      return
    }
    TWEEN.update()
    earthRef.current.rotation.set(
      earthRef.current.rotation.x,
      earthRef.current.rotation.y + Math.PI / 1200,
      earthRef.current.rotation.z
    )
  })

  useImperativeHandle(ref, () => ({
    rotateToLocation,
  }))
  const rotateToLocation = (lat, lon, isRotating) => {
    const phi = (90 - lat) * (Math.PI / 180)
    const theta = (lon + 180) * (Math.PI / 180)
    const targetRotation = { x: phi, y: theta, z: earthRef.current.rotation.z }
    if (isRotating) {
      setIsRotating(true)
      new TWEEN.Tween(earthRef.current.rotation)
        .to(targetRotation, 2000) // 2 seconds duration
        .easing(TWEEN.Easing.Quadratic.Out)
        .start()
        .onComplete(() => {
          setIsRotating(false)
        })
    } else {
      setIsRotating(true)
      new TWEEN.Tween(earthRef.current.rotation)
        .to(targetRotation, 2000) // 2 seconds duration
        .easing(TWEEN.Easing.Quadratic.Out)
        .start()
        .onComplete(() => {
          setIsRotating(true)
        })
    }
  }

  let argsSphereGeometry = props.showSelect ? [1.1, 100, 300] : [1, 300, 300]
  return (
    <>
      <mesh ref={earthRef}>
        <sphereGeometry args={argsSphereGeometry} attach="geometry" />
        <meshPhongMaterial
          attach="material"
          map={colorMap}
          bumpMap={bumpMap}
          bumpScale={0.5}
          specularMap={specularMap}
          specular={new Color("gray")}
          color={"#FFFFFF"}
        />
      </mesh>
    </>
  )
})
export default Earth
